var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-pdf-embed',{staticStyle:{"width":"100%","height":"600px"},attrs:{"source":_vm.base64Pdf}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }